import { RadioGroup } from '@platform/components';
import { UpdateType } from '.';
import { Users } from '@platform/client';

type UpdateSelectionContentProps = {
  updateType?: UpdateType;
  setUpdateType: (updateType: UpdateType) => void;
};

export const UpdateSelectionContent = (props: UpdateSelectionContentProps) => {
  const { setUpdateType } = { ...props };
  const user = Users.useGetCurrentUser();

  const updateSelectionItems = [
    {
      value: UpdateType.Completed,
      title: 'Completed',
    },
    {
      value: UpdateType.Unresponsive,
      title: `This ${user.data?.accountType == 'experteer' ? 'organization' : 'Experteer'} is unresponsive`,
    },
    {
      value: UpdateType.Other,
      title: 'I have a different update',
    },
  ];

  const validateRadio = (value: string | number | null): string | undefined => {
    if (!value) {
      return 'Select one option to continue';
    }
  };

  return (
    <div className='flex flex-col gap-8 items-center md:mt-8 md:w-[500px]'>
      <div className='text-center text-xl'>What's the status of your Discovery Call?</div>
      <div className='mt-4 w-full'>
        <RadioGroup
          name='update-selection'
          aria-label='update-selection'
          isRequired={true}
          items={updateSelectionItems}
          validate={validateRadio}
          defaultValue={props.updateType}
          onChange={(value) => {
            setUpdateType(value as UpdateType);
          }}
        />
      </div>
    </div>
  );
};
